export const appCongig = {
    mapProvider: 'google',
    refreshOnError: true,
    refreshAttempts: 5,
};